import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import UploadReportComp from "./Component/UploadReportComp"


const UploadReport =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <UploadReportComp />
        </div>
        <Footer />
        </>
    )
}

export default UploadReport